import { useEffect } from 'react';

/**
 * Custom hook to dynamically set the page title
 * @param {string} title - The title to set (will be appended with " - eHAAZRI")
 */
export const usePageTitle = (title) => {
    useEffect(() => {
        const baseTitle = 'eHAAZRI';
        document.title = title ? `${title} - ${baseTitle}` : baseTitle;

        // Cleanup function to reset title when component unmounts
        return () => {
            document.title = baseTitle;
        };
    }, [title]);
};
